export default {
  emptyPlaceholder: 'Przeciągnij i upuść pliki tutaj, aby je przesłać.',
  addFile: 'Dodaj pliki',
  removeAllFiles: 'Usuń wszystkie pliki',
};
